/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import DatetimePicker from 'vuetify-datetime-picker';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import brokenAxis from 'highcharts/modules/broken-axis';
import Moment from 'moment';
import MomentTimeZone from 'moment-timezone';
import * as VueGoogleMaps from 'vue2-google-maps';
import { apiKey } from './plugins/google-maps';
import { nodeRestApi, clearToken } from './plugins/api';

window.moment = Moment;
MomentTimeZone();

brokenAxis(Highcharts);

Highcharts.setOptions({
  time: {
    timezone: 'Asia/Kolkata'
  }
});
Vue.use(DatetimePicker);
Vue.use(HighchartsVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: apiKey,
    language: 'en',
    region: 'IN'
  }
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    const userString = localStorage.getItem('user');
    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.commit('user/setUserData', userData);
    }
    nodeRestApi.interceptors.response.use(
      response => response,
      error => {
        try {
          this.$store.commit('setError', false, { root: true });
          if (error.response) {
            if (error.response.status === 401) {
              clearToken();
              this.$store.dispatch('user/logout');
              router.push('/login');
            }
          } else {
            this.$store.commit('setError', error.message, { root: true });
          }
        } catch (e) {
          clearToken();
          this.$store.dispatch('user/logout');
          router.push('/login');
        }
        return Promise.reject(error);
      }
    );
  }
}).$mount('#app');